import { render } from "./ModuleTitle.vue?vue&type=template&id=487aa950"
import script from "./ModuleTitle.vue?vue&type=script&lang=js"
export * from "./ModuleTitle.vue?vue&type=script&lang=js"

import "./ModuleTitle.vue?vue&type=style&index=0&id=487aa950&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__